<template>
  <check-base-layout :pagetitle="pagetitle" :check-info-data="checkFrom">
    <template>
      <check-module :title="`基本信息`">
        <template>
          <el-row>
            <el-col :span="8">
              <div class="pb20">供应商名称：</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">活动标题：</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">活动状态：</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class>开始时间：</div>
            </el-col>
            <el-col :span="8">
              <div class>结束时间：</div>
            </el-col>
          </el-row>
        </template>
      </check-module>
      <check-module :title="`活动设置`">
        <template>
          <el-row>
            <el-col :span="8">
              <div class="pb20">品牌：</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">系列：</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">型号：</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="pb20">优惠额度：</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">返利比例：</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class>目标金额：</div>
            </el-col>
            <el-col :span="8">
              <div class>已完成金额：</div>
            </el-col>
          </el-row>
          <el-divider></el-divider>
        </template>
      </check-module>
      <check-module :title="`收款信息`">
        <template>
          <el-row>
            <el-col :span="8">
              <div class>收款方式：</div>
            </el-col>
            <el-col :span="8">
              <div class>收款类型：</div>
            </el-col>
            <el-col :span="8">
              <div class>收款金额：</div>
            </el-col>
          </el-row>
        </template>
      </check-module>
      <check-module :title="`银行账户`">
        <template>
          <el-row>
            <el-col :span="24">
              <div class="pb20">账户名称：</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class>银行账户：</div>
            </el-col>
            <el-col :span="8">
              <div class>开户行：</div>
            </el-col>
            <el-col :span="8">
              <div class>银行行号：</div>
            </el-col>
          </el-row>
        </template>
      </check-module>
      <check-module :title="`承兑汇票`">
        <template>
          <el-row>
            <el-col :span="8">
              <div class="pb20">承兑汇票：</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">出票单位：</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">出票银行：</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class>出票日期：</div>
            </el-col>
            <el-col :span="8">
              <div class>到期日期：</div>
            </el-col>
            <el-col :span="8">
              <div class>凭证：</div>
            </el-col>
          </el-row>
        </template>
      </check-module>
    </template>
    <template #checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'

export default {
  name: 'supplierreceiptCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '供应商活动收款审批'
    }
  }
}
</script>
